// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { bulkDeleteCrmObjectsRequestToJson, createCrmObjectRequestToJson, createCrmObjectResponseFromJson, deleteCrmObjectRequestToJson, getMultiCrmObjectRequestToJson, getMultiCrmObjectResponseFromJson, listCrmObjectsRequestToJson, listCrmObjectsResponseFromJson, listFieldOptionsRequestToJson, listFieldOptionsResponseFromJson, listFiltersRequestToJson, listFiltersResponseFromJson, restoreCrmObjectRequestToJson, updateCrmObjectRequestToJson, validateCrmObjectRequestToJson, validateCrmObjectResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function createCustomObject(request) {
    const raw = await fetchRpc('crm.v1.CRMCustomObjectService/CreateCustomObject', createCrmObjectRequestToJson(request));
    return createCrmObjectResponseFromJson(raw);
}
export function createCustomObject$(request, options) {
    return defer(() => createCustomObjectWithTransport$(getGlobalTransport(), request, options));
}
export function createCustomObjectWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCustomObjectService/CreateCustomObject', createCrmObjectRequestToJson(request), options)
        .pipe(map(resp => createCrmObjectResponseFromJson(resp)));
}
export async function getMultiCustomObject(request) {
    const raw = await fetchRpc('crm.v1.CRMCustomObjectService/GetMultiCustomObject', getMultiCrmObjectRequestToJson(request));
    return getMultiCrmObjectResponseFromJson(raw);
}
export function getMultiCustomObject$(request, options) {
    return defer(() => getMultiCustomObjectWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiCustomObjectWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCustomObjectService/GetMultiCustomObject', getMultiCrmObjectRequestToJson(request), options)
        .pipe(map(resp => getMultiCrmObjectResponseFromJson(resp)));
}
export async function updateCustomObject(request) {
    await fetchRpc('crm.v1.CRMCustomObjectService/UpdateCustomObject', updateCrmObjectRequestToJson(request));
}
export function updateCustomObject$(request, options) {
    return defer(() => updateCustomObjectWithTransport$(getGlobalTransport(), request, options));
}
export function updateCustomObjectWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCustomObjectService/UpdateCustomObject', updateCrmObjectRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function deleteCustomObject(request) {
    await fetchRpc('crm.v1.CRMCustomObjectService/DeleteCustomObject', deleteCrmObjectRequestToJson(request));
}
export function deleteCustomObject$(request, options) {
    return defer(() => deleteCustomObjectWithTransport$(getGlobalTransport(), request, options));
}
export function deleteCustomObjectWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCustomObjectService/DeleteCustomObject', deleteCrmObjectRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function restoreCustomObject(request) {
    await fetchRpc('crm.v1.CRMCustomObjectService/RestoreCustomObject', restoreCrmObjectRequestToJson(request));
}
export function restoreCustomObject$(request, options) {
    return defer(() => restoreCustomObjectWithTransport$(getGlobalTransport(), request, options));
}
export function restoreCustomObjectWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCustomObjectService/RestoreCustomObject', restoreCrmObjectRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listCustomObjects(request) {
    const raw = await fetchRpc('crm.v1.CRMCustomObjectService/ListCustomObjects', listCrmObjectsRequestToJson(request));
    return listCrmObjectsResponseFromJson(raw);
}
export function listCustomObjects$(request, options) {
    return defer(() => listCustomObjectsWithTransport$(getGlobalTransport(), request, options));
}
export function listCustomObjectsWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCustomObjectService/ListCustomObjects', listCrmObjectsRequestToJson(request), options)
        .pipe(map(resp => listCrmObjectsResponseFromJson(resp)));
}
export async function validateCustomObject(request) {
    const raw = await fetchRpc('crm.v1.CRMCustomObjectService/ValidateCustomObject', validateCrmObjectRequestToJson(request));
    return validateCrmObjectResponseFromJson(raw);
}
export function validateCustomObject$(request, options) {
    return defer(() => validateCustomObjectWithTransport$(getGlobalTransport(), request, options));
}
export function validateCustomObjectWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCustomObjectService/ValidateCustomObject', validateCrmObjectRequestToJson(request), options)
        .pipe(map(resp => validateCrmObjectResponseFromJson(resp)));
}
export async function listCustomObjectFilters(request) {
    const raw = await fetchRpc('crm.v1.CRMCustomObjectService/ListCustomObjectFilters', listFiltersRequestToJson(request));
    return listFiltersResponseFromJson(raw);
}
export function listCustomObjectFilters$(request, options) {
    return defer(() => listCustomObjectFiltersWithTransport$(getGlobalTransport(), request, options));
}
export function listCustomObjectFiltersWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCustomObjectService/ListCustomObjectFilters', listFiltersRequestToJson(request), options)
        .pipe(map(resp => listFiltersResponseFromJson(resp)));
}
export async function listCustomObjectFieldOptions(request) {
    const raw = await fetchRpc('crm.v1.CRMCustomObjectService/ListCustomObjectFieldOptions', listFieldOptionsRequestToJson(request));
    return listFieldOptionsResponseFromJson(raw);
}
export function listCustomObjectFieldOptions$(request, options) {
    return defer(() => listCustomObjectFieldOptionsWithTransport$(getGlobalTransport(), request, options));
}
export function listCustomObjectFieldOptionsWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCustomObjectService/ListCustomObjectFieldOptions', listFieldOptionsRequestToJson(request), options)
        .pipe(map(resp => listFieldOptionsResponseFromJson(resp)));
}
export async function bulkDeleteCustomObjects(request) {
    await fetchRpc('crm.v1.CRMCustomObjectService/BulkDeleteCustomObjects', bulkDeleteCrmObjectsRequestToJson(request));
}
export function bulkDeleteCustomObjects$(request, options) {
    return defer(() => bulkDeleteCustomObjectsWithTransport$(getGlobalTransport(), request, options));
}
export function bulkDeleteCustomObjectsWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCustomObjectService/BulkDeleteCustomObjects', bulkDeleteCrmObjectsRequestToJson(request), options)
        .pipe(map(() => undefined));
}
